import {load} from '@cashfreepayments/cashfree-js';

const cashfree = await load({
  mode: process.env.REACT_APP_CASHFREE_MODE,
});

export default cashfree;